<template>
  <el-card v-if="messageDisplay"
          class="card-flex --no-box-shadow"
          shadow="never">
    <div :class="['card-flex__wrapper', isColumn && '--is-column',
     noBoxShadow && '--no-box-shadow',
    mobileWrapperColumn && '--is-mobile__wrapper__column']">
      <div
        v-if="closeMessage"
        class="card-flex__close"
        @click="messageDisplay = false">
        <font-awesome-icon :icon="['fal', 'times']" />
      </div>
      <img v-if="image" class="card-flex__img"
           alt=""
           :src="image" />
      <font-awesome-icon v-if="icon" :icon="icon" :size="iconSize"
                         :class="['card-flex__icon',
                         iconSize ? '': '--size-fix',
                         iconGreen ? 'icon_green' : '']"></font-awesome-icon>
      <div class="card-flex__content" v-if="content" v-html="content"></div>
      <div class="card-flex__content" v-else>
        <h3 v-if="title" class="card-flex__title">{{title}}</h3>
        <slot></slot>
      </div>
      <div v-if="$slots.after" class="card-flex__after">
        <slot name="after"></slot>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'card-flex',
  props: {
    content: String,
    image: String,
    title: String,
    icon: Array,
    iconSize: String,
    iconGreen: Boolean,
    mobileWrapperColumn: Boolean,
    noBoxShadow: Boolean,
    closeMessage: Boolean,
    isColumn: Boolean,
  },
  data() {
    return {
      messageDisplay: true,
    };
  },
};
</script>

<style scoped lang="scss">
.--no-box-shadow {
  box-shadow: none;
}

.card-flex {
  margin-bottom: 20px;

  &__wrapper {
    display: flex;
    align-items: center;

    &.--is-mobile__wrapper__column {
      flex-direction: column;

      .card-flex {
        &__img, &__icon {
          margin-bottom: 10px;
          margin-right: 0;
        }

        &__after {
          margin-top: 10px;
        }
      }

      @include breakpoint(mobile) {
        &:not(.card-flex__wrapper.--is-column) {
          flex-direction: row;

          .card-flex {
            &__img, &__icon, &__after {
              margin: {
                top: 0;
                bottom: 0;
              }
            }

            &__img, &__icon {
              margin-right: 20px;
            }
          }
        }
      }
    }
  }

  &__icon.icon_green {
    color: var(--nxt-color-secondary);
  }

  &__img, &__icon.--size-fix {
    width: 32px;
  }
  &__img, &__icon {
    margin-right: 20px;
  }

  &__icon.--size-fix {
    height: 32px;
  }

  &__img {
    height: 32px;
    width: auto;
  }

  &__content {
    text-align: center;
    margin: auto;
    flex: 1 1 auto;
    @include breakpoint(mobile) {
      text-align: left;
      margin: auto;
    }
  }

  &__close {
    cursor: pointer;
    align-self: end;
    position: relative;
    top: -5px;
    @include breakpoint(mobile) {
      align-self: center;
      order: 3;
      top: 0;
    }
  }

  &__title {
    margin: 0;
  }

  @include breakpoint(mobile) {
    &__after {
      margin-left: 20px;
    }
  }

}
</style>
